export default __webpack_public_path__ + "static/media/2412253.594c7a06.webp";